'use strict';
 /**
 * @author Maxim Seredkin
 */
export default ['$uibModal', 'SignRestService',
    function ($modal, SignRestService) {

        return {
            select: select,
            api: SignRestService
        };

        function select(certs) {
            return $modal.open({
                template: require('../view/cert-select-modal.html'),
                controller: 'CertSelectModal',
                controllerAs: 'vm',
                size: 'w1200',
                backdrop: false,
                resolve: {
                    certs: function () {
                        return certs;
                    },
                }
            });
        }

    }];